import { Button, Card, Form, Input, Typography, Layout, message } from "antd";
import { MailOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useState } from "react";
import axios from "../../services/axiosInstance";
import { RESET_PASSWORD } from "../../services/apiEndPoints";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;
const { Content } = Layout;

export default function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: { email: any }) => {
    setLoading(true);
    try {
      const response = await axios.post(RESET_PASSWORD, {
        memberEmail: values.email,
      });

      const data = response.data;

      if (response.status !== 200) {
        throw new Error(data.message || "Something went wrong");
      }

      message.success("Password reset link sent to your email 📧");
    } catch (error) {
      message.error(
        error instanceof Error ? error.message : "Failed to send reset link"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="login-layout">
      {/* Decorative Side */}
      <div className="login-decor">
        <div className="decor-circle decor-1" />
        <div className="decor-circle decor-2" />

        <div className="decor-content">
          <Title level={2} style={{ color: "#fff" }}>
            Forgot Password? 🔐
          </Title>
          <Text style={{ color: "#e5e7eb" }}>We’ll help you get back in</Text>
        </div>
      </div>

      {/* Forgot Password Form */}
      <Content className="login-content">
        <Card className="login-card">
          <Title level={3}>Reset Password</Title>
          <Text type="secondary">
            Enter your registered email address and we’ll send you a reset link.
          </Text>

          <Form
            layout="vertical"
            style={{ marginTop: 24 }}
            onFinish={handleSubmit}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Enter your email address" },
                { type: "email", message: "Enter a valid email" },
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="you@example.com" />
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              loading={loading}
            >
              Send Reset Link
            </Button>

            <Link to="/login">
              <Button
                type="link"
                block
                icon={<ArrowLeftOutlined />}
                style={{ marginTop: 12 }}
              >
                Back to Login
              </Button>
            </Link>

            <Text type="secondary" style={{ display: "block", marginTop: 16 }}>
              © 2025 Access Warehousing
            </Text>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
}
